import { Account } from '../../../../models/customer';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { SelectedAccountsSettings } from '../selected-accounts-settings';
import { I18N } from 'aurelia-i18n';

@autoinject()
export class CardInstallmentSetup {
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;
	numberOfOptions: number = 0;
	message: string = '';

	constructor(private i18n: I18N, private router: Router) {}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.selectedAccountsSettings = model.selectedAccountsSettings;
			this.getRanges();
		}
	}

	getRanges() {
		this.numberOfOptions = 0;
		let account = this.selectedAccounts[0];

		let balanceRanges = this.selectedAccountsSettings.installmentBalanceRanges[account.id];
		if (balanceRanges) {
			// Assume only 1 account
			balanceRanges.forEach((range) => {
				// Find range within account balance
				if (account.balance >= range.min && account.balance <= range.max) {
					this.numberOfOptions += range.installments.length || 0;
				}
			});

			this.setMessageText();
		}
	}

	setMessageText() {
		this.message = this.i18n.i18next.t('setupPaymentPlanFromOptions', { defaultValue: `Set-up a payment plan from ${this.numberOfOptions} different options`, number: this.numberOfOptions });
	}

	setupPlan = () => {
		const setupPlanRoute = this.router.routes.find(x => x.name === 'installments/select-option');
		setupPlanRoute.accounts = this.selectedAccounts;
		this.router.navigateToRoute(setupPlanRoute?.name, { id: this.selectedAccounts[0].id });
	}
}
